const MonitorIcon = ({ color = '#9CA3AF', size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.5" y="4" width="19" height="13" rx="2" stroke={color} strokeWidth="1.6" />
    <path d="M8 21h8M12 17v4" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
)

export default MonitorIcon
